import { useState } from "react";

import { LegendIcon } from "src/design-system/LegendIcon";
import { Pill } from "src/design-system/Pill";
import { Tooltip } from "src/design-system/Tooltip";

type StatusPillProps = {
  color: "green" | "indigo" | "yellow";
  value: string | number;
  tooltip: {
    title: string;
    body?: React.ReactNode;
  };
};

export const ResourceStatusPill: React.FC<StatusPillProps> = ({
  color,
  value,
  tooltip,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Tooltip
      body={tooltip.body}
      open={isHovered}
      placement="bottom"
      title={tooltip.title}
      asChild
      onOpenChange={setIsHovered}
    >
      <Pill hovered={isHovered} size="md" variant="outlined-white">
        <LegendIcon color={`${color}-400`} />
        <Pill.Text>{value}</Pill.Text>
      </Pill>
    </Tooltip>
  );
};

export const ResourceStatusPillContainer: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return <div className="[&>*:not(:first-child)]:-ml-1.5">{children}</div>;
};
